import { I74Form } from 'clickNgo/models/crud/forms/i74Form'
import { ICrudFetchOptions } from 'clickNgo/models/crud/utils'
import { CrudStoreItemCore } from 'core/classes/services/InitializationServiceCore'
import { CrudStore } from 'core/types/crudStore'
import Logger from 'core/utils/Logger'

import { mapCountryFrom74Form } from './mapping/mapCountryFrom74Form'

export const fetchCountryByName = (countryName: string, options?: ICrudFetchOptions) => {
  const crud = CrudStore.get<I74Form>(CrudStoreItemCore.Countries, options?.cacheKey)

  return crud
    .getById({ id: countryName, force: options?.isForce, keyField: 'en' })
    .then((result: I74Form) => {
      if (result && result.EntryId) {
        return mapCountryFrom74Form(result)
      }

      return
    })
    .catch((e) => {
      Logger.error(e)
      return
    })
}
